import * as React from 'react';

import type {
    ContactSearchResult as ContactSearchResultFragment,
    AccountSearchResult as AccountSearchResultFragment,
    LeadSearchResult as LeadSearchResultFragment,
} from 'nutshell-graphql-types';

import {SearchResultLead} from './search-result-lead';
import {SearchResultPeep} from './search-result-peep';

type Props = {
    searchResult:
        | ContactSearchResultFragment
        | AccountSearchResultFragment
        | LeadSearchResultFragment;
    isActive?: boolean;
    closeSidebar: () => void;
};

export class SearchResult extends React.PureComponent<Props> {
    render() {
        switch (this.props.searchResult.__typename) {
            case 'Lead':
                return React.createElement(SearchResultLead, {
                    ...this.props.searchResult,
                    isActive: this.props.isActive,
                    closeSidebar: this.props.closeSidebar,
                });
            case 'Account':
            case 'Contact':
                return React.createElement(SearchResultPeep, {
                    peep: this.props.searchResult,
                    // @ts-expect-error
                    isActive: this.props.isActive,
                    closeSidebar: this.props.closeSidebar,
                });
            default:
                return null;
        }
    }
}
